import type { Theme } from '@mui/material';

import { muiSelectStyles } from 'src/theme/sharedStyles';

export const styles = {
  paginationContainer: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: 2,
    py: 1,
    color: theme.colors.neutral[700],
  }),

  selectContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  paginationButtonsContainer: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',

    button: {
      color: theme.colors.neutral[800],
      p: 0,

      '&:disabled': {
        color: theme.colors.neutral[300],
      },
    },
  }),

  selectDropdown: (theme: Theme) => ({
    ...muiSelectStyles.filterSelect(theme),
    backgroundColor: theme.colors.white,
    minWidth: '3rem',
    color: theme.colors.neutral[700],

    svg: {
      fill: theme.colors.neutral[700],
    },
  }),

  menuProps: muiSelectStyles.filterPaper,

  menuItem: muiSelectStyles.filterMenuItem,

  label: {
    fontSize: 12,
    fontWeight: 600,
  },
};
